import { CircularProgress, MenuItem, TextField } from '@mui/material';
import { useController } from 'react-hook-form';
import { DropDownOption } from 'shared/types';

interface DropdownFieldProps {
  name: `${string}` | `${string}.${string}` | `${string}.${number}`;
  label: string;
  rules?: Object;
  error?: boolean;
  helperText?: string;
  readOnly?: boolean;
  options: DropDownOption[];
  loading?: boolean;
}
export function DropdownField({
  name,
  label,
  rules,
  error,
  helperText,
  readOnly,
  options,
  loading,
}: DropdownFieldProps) {
  const { field } = useController({
    name,
    rules,
    defaultValue: '',
  });
  return (
    <TextField
      {...field}
      variant='outlined'
      fullWidth
      label={label}
      error={error}
      helperText={helperText}
      select
      disabled={readOnly}
      id={name}
      InputProps={{ endAdornment: loading && <CircularProgress color='inherit' size={20} /> }}
      inputProps={{ 'data-testid': `${name}-input` }}
    >
      {options.map(option => (
        <MenuItem key={option.value} value={option.value}>
          {option.key}
        </MenuItem>
      ))}
    </TextField>
  );
}
